document.addEventListener("DOMContentLoaded", function () {
    let iconCardsList = document.querySelectorAll('.icons-card-row');
    iconCardsList.forEach(function(iconCards) {
        let Children = iconCards.querySelectorAll('.icon-card').length;

        if (Children == 4) {
            iconCards.classList.add('card-row-small');
        }
        if (Children == 3) {
            iconCards.classList.add('card-row-medium');
        }
        if (Children == 2) {
            iconCards.classList.add('card-row-large');
        }
    });
});
